import { createContext, useContext } from "react";

import { DEFAULT_SSR_ROUTE_DATA, type SsrRouteData } from "@/ssr/routeData";

type SsrStatusRef = {
  current: number;
};

type SsrContextValue = {
  routeData: SsrRouteData;
  statusRef?: SsrStatusRef;
};

const SsrContext = createContext<SsrContextValue>({
  routeData: DEFAULT_SSR_ROUTE_DATA,
});

export function SsrContextProvider({
  children,
  routeData,
  statusRef,
}: {
  children: React.ReactNode;
  routeData?: SsrRouteData;
  statusRef?: SsrStatusRef;
}) {
  return (
    <SsrContext.Provider
      value={{
        routeData: routeData ?? DEFAULT_SSR_ROUTE_DATA,
        statusRef,
      }}
    >
      {children}
    </SsrContext.Provider>
  );
}

export const useSsrRouteData = () => useContext(SsrContext).routeData;

export const useSetSsrStatusCode = () => {
  const { statusRef } = useContext(SsrContext);

  return (statusCode: number) => {
    if (!statusRef) return;
    if (!Number.isFinite(statusCode)) return;
    statusRef.current = Math.max(100, Math.min(599, Math.floor(statusCode)));
  };
};
